<div class="remove-profile-container">
  <mat-card class="delete-card">

    <mat-card-header>
      <mat-card-title class="title">
        {{staticText?.common?.delete_account ?? 'Delete Account'}}
      </mat-card-title>
      <mat-card-subtitle
      class="subtitle">{{staticText?.common?.validation_error_msg?.confirm_details ?? "Please confirm your details to proceed"}}</mat-card-subtitle>
    </mat-card-header>

    <mat-card-content>
      <form [formGroup]="deleteForm">
        <!-- Email -->
        <mat-form-field appearance="outline" class="mb-4">
          <mat-label>{{staticText?.common?.email}}</mat-label>
          <input id="emailInput" matInput formControlName="email" placeholder="Enter email" [attr.aria-label]="staticText?.common?.email || 'Email'" />
          @if (deleteForm.get('email')?.hasError('required')) {
            <mat-error>
              {{staticText?.common?.validation_error_msg?.email_required ?? "Email is required"}}
            </mat-error>
          }
          @if (deleteForm.get('email')?.hasError('email')) {
            <mat-error>
              {{staticText?.common?.validation_error_msg?.email_invalid ?? "Enter a valid email address format" }}
            </mat-error>
          }
        </mat-form-field>

        <!-- Mobile Number -->
        <mat-form-field appearance="outline" class="mt-2">
          <mat-label>{{staticText?.common?.mobile_number ?? "Mobile Number" }}</mat-label>
          <span matPrefix class="mat_prefix">+250 &nbsp;</span>
          <input id="mobileNumberInput" matInput formControlName="mobileNumber" placeholder="Mobile number" [attr.aria-label]="staticText?.common?.mobile_number || 'Mobile Number'" />
          @if (deleteForm.get('mobileNumber')?.hasError('required')) {
            <mat-error>
              {{staticText?.common?.mobile_number_required ?? "Mobile number is required."}}
            </mat-error>
          }
          @if (deleteForm.get('mobileNumber')?.hasError('pattern')) {
            <mat-error>
              {{staticText?.common?.valid_mobile_number}}
            </mat-error>
          }
        </mat-form-field>


      </form>
    </mat-card-content>

    <mat-card-actions>
      <button class="btn_default_user " (click)="deleteAccount()">
        {{staticText?.common?.delete_account ?? 'Delete Account'}}
      </button>
    </mat-card-actions>

  </mat-card>
</div>